module.exports = __webpack_public_path__ + "static/AcuminProExtraLight-13453bf5a62ecb76528e81a4299c88dd.otf";